import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { REACT_APP_FEATURE_FLAG_SEARCH_ENGINE } from '../../config/settings/environment'

/**
 * The ProtectByFeatures' component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props
  const navigate = useNavigate()
  const features = {
    'com.buyer/search.engine':
      REACT_APP_FEATURE_FLAG_SEARCH_ENGINE === true || REACT_APP_FEATURE_FLAG_SEARCH_ENGINE === 'true'
  }

  const result = rule(features)

  if (!result && redirectTo) {
    navigate(redirectTo, { replace: true })
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
